<template>
<div>
    <div class="content scrollable">
        <div style="grid-area: messages; padding: 0.5rem">
            <div v-for="(msg, index) in messages" v-bind:key="index"
                class="alert alert-dismissible"
                :class="{
                    'alert-info': msg.type == 'INFO',
                    'alert-danger': msg.type == 'ERROR'}">
                <a href="#" @click="closeMessage(index)" class="close" aria-label="close">&times;</a>
                {{ msg.message }}
            </div>
        </div>
        <div style="grid-area: tabs">

            <h5 class="p-2 text-primary">Verwaltungsoberfläche</h5>

            <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li v-for="(editor, index) in editors" v-bind:key="index" class="nav-item" >
                    <div
                        class="nav-link p-2"
                        :class="{active: editor.isActive, 'pr-1': index > 0}"
                    >
                        <a
                            class="" style="display: inline-block !important; text-decoration: none;"
                            @click="switchTab(index)"
                            id=""
                            data-toggle="tab"
                            href="#"
                            role="tab"
                            aria-controls="contact"
                            :aria-selected="editor.isActive"
                        >
                            {{ editor.name }}
                        </a>
                    </div>
                </li>
            </ul>
        </div>

        <div class="tab-content pr-4" id="myTabContent">
            <div
                v-for="(editor, index) in editors"
                v-bind:key="editor"
                class="tab-pane fade"
                :class="{show: editor.isActive, active: editor.isActive}"
                :id="index"
                role="tabpanel"
                aria-labelledby="post-payable-tab"
            >
                <component
                    :is="editor.type"
                    :key="editor"
                    v-bind:editor_data="editor.data"
                    v-on:delete-tab="deleteThisTab(index)"
                ></component>
            </div>
        </div>

    </div></div>

</template>

<script>
import AddUser from './AddUser.vue';
import EditUser from './EditUser.vue';
import axios from "axios";
import AddFinAccount from './AddFinAccount.vue';
import EditFinAccount from './EditFinAccount.vue';
import AddGroup from './AddGroup.vue';
import EditGroup from './EditGroup.vue';
import ExportAllTransactions from "@/components/AdminArea/ExportAllTransactions.vue";

const api_url = process.env.VUE_APP_ROOT_API;

function cleanId(id) {
    if (Array.isArray(id)) {
        return id[1];
    }
}

export default {
    name: 'ManagementContent',
    components: {
        AddUser, EditUser, AddFinAccount, EditFinAccount, AddGroup, EditGroup, ExportAllTransactions
    },
    data() {
        return {
            account: 'Default',
            error_msg: 'No Error',
            editors: [],
            current_tab: 0,
        }
    },
    methods: {
        loadInitialData: function() {
            //this.$store.commit('switch_account', 'Handkasse')
            this.$store.dispatch('loadData')
            // eslint-disable-next-line
            console.log("Dispatching loadUserData...");
            this.$store.dispatch("loadUserData");
            // eslint-disable-next-line
            console.log("Dispatching loadGroupData...");
            this.$store.dispatch("loadGroupData");
            //this.$store.commit('switch_account', this.$store.state.acc_list.accounts[0].accounts[0].name)

            //this.$store.commit('switch_account', 'FSR 1 Handkasse')
            var ownGroup = ""
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            if (!credentials) {
                credentials = this.$store.state.credentials
            }

            /*Promise.all(axios({
                url: process.env.VUE_APP_ROOT_API,
                auth: credentials,
                method: 'get'})*/
            //axios.get(process.env.VUE_APP_ROOT_API)
            axios({
                url: process.env.VUE_APP_ROOT_API,
                auth: credentials,
                method: 'get'})
            .then(response => {
                ownGroup = response.data.ownGroup;
                // eslint-disable-next-line
                console.log("Owngroup: " + ownGroup)
                if (ownGroup === "admin") {
                    this.editors.push({
                        type: AddUser,
                        name: "User hinzufügen",
                        isActive: true,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "USER"
                    })
                }
                this.editors.push({
                    type: EditUser,
                    name: "User bearbeiten",
                    isActive: ownGroup !== "admin",
                    data: {
                        t_text: "Test"
                    },
                    editorType: "USER"
                })
                if (ownGroup === "admin") {
                    this.editors.push({
                        type: AddFinAccount,
                        name: "Konto hinzufügen",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "ACCOUNT"
                    })
                    this.editors.push({
                        type: EditFinAccount,
                        name: "Konto bearbeiten",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "ACCOUNT"
                    })
                    this.editors.push({
                        type: AddGroup,
                        name: "Gruppe hinzufügen",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "GROUP"
                    })
                    this.editors.push({
                        type: EditGroup,
                        name: "Gruppe bearbeiten",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "GROUP"
                    });
                    this.editors.push({
                        type: ExportAllTransactions,
                        name: "Datensatz Exportieren",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "NONE"
                    });
                    this.editors.push({
                        type: () => import('./AuditLog.vue'),
                        name: "Audit-Log",
                        isActive: false,
                        data: {
                            t_text: "Test"
                        },
                        editorType: "NONE"
                    });
                }
                })
            .catch(e => {
            })

        },
        switchTab: function(tab_index) {
            this.current_tab = tab_index
            this.editors.forEach(editor => {
                editor.isActive = false
            });
            //console.log(tab_index)
            this.editors[tab_index].isActive = true
            // eslint-disable-next-line
            console.log(this.editors[tab_index].editorType)
            this.$store.commit('switch_editor', this.editors[tab_index].editorType)
            this.$store.dispatch('loadUserData')
        },
        deleteThisTab: function(tab_index) {
            this.editors.splice(tab_index, 1)
            var switch_index = 0
            if (tab_index == this.current_tab) {
                if (tab_index == this.editors.length)
                    switch_index = tab_index - 1
                else
                    switch_index = tab_index
                this.switchTab(switch_index)
            }

        },
        computeValue: function(amount) {
            var num = new Number(amount / 100);
            return parseFloat(Math.round(num * 100) / 100)
                .toFixed(2)
                .toString()
                .replace('.', ',');
        },
        closeMessage: function(msg) {
            this.$store.commit('remove_message', msg)
        },
        reverseTransaction: function(entry) {
            var editor_data = {
                t_text: entry.text,
                t_counterAcc: entry.counter_acc,
                t_amount: this.computeValue(entry.tx_amount + entry.rx_amount).replace(',', '.'),
                t_transaction_id: entry.id,
                t_action_type: entry.tx_amount == 0 ? "INPUT" : "OUTPUT",
                t_receiptInfo: entry.receiptInfo,
                t_txAcc: entry.txAcc,
                t_rxAcc: entry.rxAcc,
                t_date: entry.date
            }
            var i = this.editors.push({
                type: BookReverseEntry,
                name: "Stornieren",
                isActive: false,
                data: editor_data
            })
            this.switchTab(i-1)
        },
        downloadDocument(id) {
            var clean_id = this.$filters.cleanId(id)
            var credentials = JSON.parse(localStorage.getItem('credentials'))
            axios({
                url: api_url + "/documents/" + this.accountName + "/" + clean_id,
                method: 'GET',
                responseType: 'blob', // important,
                auth: credentials
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', 'kassenanordnung.odt'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });
        },
        switchSorter(sorter) {
            if (this.current_sorter == sorter) {
                this.reversed = !this.reversed
            } else {
                this.reversed = true
                this.current_sorter = sorter
            }
        }
    },
    computed: {
        accountName () {
            if (this.$store.state.account_info) {
                return this.$store.state.current_acc
            } else {
                return null
            }
        },
        accountInfo() {
            if (this.$store.state.account_info) {
                return this.$store.state.account_info
            } else {
                return this.account
            }
        },
        sortedEntries() {
            if (this.reversed) {
                return this.accountInfo.entries.slice().sort(this.current_sorter).reverse()
            }
            return this.accountInfo.entries.slice().sort(this.current_sorter)
        },
        messages() {
            return this.$store.state.messages;
        },
        ownGroup() {
            // eslint-disable-next-line
            console.log("this.$store.state.remote");
            // eslint-disable-next-line
            console.log(this.$store.state.remote);
            if (this.$store.state.remote === null) {
                return ""
            }
            return this.$store.state.remote.ownGroup
        }
    },
    beforeMount(){
        this.loadInitialData()
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table td.fit,
    .table th.fit {
        /*white-space: nowrap;*/
        width: 1%;
    }
    .scrollable {
        overflow-y: auto;
        max-height: 100%;
    }
    .fill {
        min-height: 100%;
        height: 100%;
    }
    .vcenter {
        margin-top: auto;
        margin-bottom: auto;
    }

</style>
